// removed by extract-text-webpack-plugin
module.exports = {"NoEthereumSection":"_1XI2ym1KawIuSKgwa4d22E","ImgHeaderLogo":"_1sz6d3dYMlLGwSQNHYIjc0","ImgEthereumLogo":"_3Jm6Xz069vZWPnVRCSen2d","HorizontalLine":"_1fS143UvUj2jlZexQqDlEw"};


//////////////////
// WEBPACK FOOTER
// ./src/components/WaitingForAccess.scss
// module id = 488
// module chunks = 0